<template>
  <div style="width: 100%">
    <div style="display: flex; flex-direction: column; width: 100%">
      <div
        v-for="(v, k) in groupedData"
        :key="k"
        style="display: flex; flex-direction: row; justify-content: center; line-height: 32px"
      >
        <div style="width: 40%; text-align: right; padding-right: 1ex; font-size: 15px; display: flex; align-items: center; justify-content: flex-end">{{ k }}</div>
        <div style="width: 60%; display: flex; margin: 6px 0 6px 0">
          <div
            class="foreground-bar"
            :style="{ width: (70 * v.selected) / maxCount + '%' }"
          >
          </div>
          <div
            class="background-bar"
            style="display: inline-block"
            :style="{ width: (70 * v.notSelected) / maxCount + '%' }"
          >
          </div>
          <!-- <div style="display: inline-block">{{ JSON.stringify(v) }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    acornCodesTotalPopulation: {
      default: {
        1: 1,
        2: 2,
        3: 3,
        4: 4,
      },
    },
    acornCodesFilteredPopulation: {
      default: {
        1: 1,
        2: 1,
        3: 1,
        4: 1,
      },
    },
  },
  computed: {
    groupedData() {
      // OK, this thing returns:
      // {
      // [group]: {
      //   selected: [number],
      //   notSelected: [number]
      // }
      //}

      const P = this.acornCodesTotalPopulationWithZeros;

      // TODO better function name
      const process = (acc, code) => {
        const total = this.acornCodesTotalPopulation[code] ?? 0;
        const selectedAmount = this.acornCodesFilteredPopulation[code] ?? 0;
        acc.selected += selectedAmount;
        acc.notSelected += total - selectedAmount;
        // if (this.selectedAcornCodes.includes(code)) {
        //   acc.selected += P[code]
        // } else {
        //   acc.notSelected += P[code]
        // }
        return acc
      }
      
      function groupAcornCodes(codes) {
        return [...codes].reduce(process, {selected: 0, notSelected: 0})
      }

      return {
        // Affluent Achievers
        "Lavish Lifestyles": groupAcornCodes(["1", "2", "3"]),
        "Executive Wealth": groupAcornCodes(["4", "5", "6", "7", "8", "9"]),
        "Mature Money": groupAcornCodes(["10", "11", "12", "13"]),
        // Rising Prosperity
        "City Sophisticates": groupAcornCodes(["14", "15", "16", "17"]),
        "Career Climbers": groupAcornCodes(["18", "19", "20"]),
        // Comfortable Communities
        "Countryside Communities": groupAcornCodes(["21", "22", "23"]),
        "Successful Suburbs": groupAcornCodes(["24", "25", "26"]),
        "Steady Neighbourhoods": groupAcornCodes(["27", "28", "29"]),
        "Comfortable Seniors": groupAcornCodes(["30", "31"]),
        "Starting Out": groupAcornCodes(["32", "33"]),
        // Financially Streched
        "Student Life": groupAcornCodes(["34", "35", "36"]),
        "Modest Means": groupAcornCodes(["37", "38", "39", "40"]),
        "Striving Families": groupAcornCodes(["41", "42", "43", "44"]),
        "Poorer Pensioners": groupAcornCodes(["45", "46", "47", "48"]),
        // Urban Adversity
        "Young Hardship": groupAcornCodes(["49", "50", "51"]),
        "Struggling Estates": groupAcornCodes(["52", "53", "54", "55", "56"]),
        "Difficult Circumstances": groupAcornCodes(["57", "58", "59"]),
        // Not Private Households
        "Not Private Households": groupAcornCodes(["60", "61", "62"]),
      };
    },
    acornCodesTotalPopulationWithZeros() {
      return Object.fromEntries(
        [...Array(63).keys()].map((i) => [
          i,
          this.acornCodesTotalPopulation[i] || 0,
        ])
      );
    },
    selected() {
      return Object.fromEntries(
        Object.entries(this.acornCodesTotalPopulation).filter((v) =>
          this.selectedAcornCodes.includes(v[0])
        )
      );
      // return {
      //   1: 0,
      //   2: 0,
      //   3: 0,
      //   4: 0,
      //   5: 0,
      //   6: 3,
      //   7: 0,
      //   8: 3,
      //   9: 0,
      // };
    },
    maxCount() {
      return Object.values(this.acornCodesTotalPopulationWithZeros).reduce(
        (prev, curr) => (prev > curr ? prev : curr),
        0
      );
    },
  },
};
</script>

<style lang="scss" scoped>

.background-bar {
  background-color: #787878;
  text-align: right;
  transition: all .5s ease-in-out;
}
.foreground-bar {
  background-color: #A9B4F9;
  text-align: right;
  transition: all .5s ease-in-out;
}
</style>
